module.exports = __webpack_public_path__ + "img/hic-tuberculosis-female.43a89ef4.png";